export enum GCSResourceType { gallery, assets, store };

export enum PageTitles { home, about, gallery, menu, access, contact };